// @greenlight-spec: 19-design-system.md
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** Deterministic hue (0–359) from a string, for generated avatar/monogram tints. */
export function stringToHue(s: string): number {
  if (!s) return 0; // resilient to empty/missing input even if a caller bypasses the type
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (h * 31 + s.charCodeAt(i)) & 0xffff;
  }
  return h % 360;
}
